import React, { useEffect, useState, useContext } from "react";
import moment from "moment/moment";
import "moment/locale/th";
import { useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import { RedirectCode400 } from "../../../RedirectCode400";
import TableSearchV1 from "../../../tableV1/tableSearchV1";
import format from "date-fns/format";
import { FaEye, FaEdit, FaTrash, FaCircle } from "react-icons/fa";
import { useLocation } from "react-router";

function ViewQuestionnaire() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [guidelineList, setGuidelineList] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalGuideline, setTotalGuideline] = useState(null);
  const [announcementListStorage, setAnnouncementListStorage] = useState([]);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });
  
  const [filters, setFilters] = useState({
    id: location?.state?.id,
    "submitter.fname": "",
    "submitter.lname": "",
    "create_date.date": "",
  });

  useEffect(() => {
    if (location?.state.type !== "view-questionnaire") {
      navigate("/");
    }
    fetchGuidelines();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [page, filters, sortBy]);

  const fetchGuidelines = async () => {
    setLoading(true);
    let res = await adminApi.getQuestionnaireQuestion(
      page,
      10,
      filters.id,
      filters["submitter.fname"],
      filters["submitter.lname"],
      formatDate(filters["create_date.date"]),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setGuidelineList(res["data"]["questionnaire_list"]);
        setAnnouncementListStorage(res["data"]["questionnaire_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotalGuideline(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const removeContent = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeQuestionnaireQuestion(
      item["user_questionnaire_answer_id"],
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        fetchGuidelines();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setGuidelineList([]);
      setAnnouncementListStorage([]);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const optionStatusList = [
    {
      value: true,
      name: "Active",
    },
    {
      value: false,
      name: "InActive",
    },
  ];

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "Ip Address",
      accessor: "ip",
    },
    {
      Header: "ชื่อคนที่ตอบ",
      accessor: "submitter.fname",
      Filter: "text",
    },
    {
      Header: "นามสกุลคนที่ตอบ",
      accessor: "submitter.lname",
      Filter: "text",
    },
    {
      Header: "วันที่ตอบ",
      accessor: "create_date.date",
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate(
                  `/admin/management/questionnaire/detail-questionnaire`,
                  {
                    state: {
                      type: "view-questionnaire",
                      id: i["user_questionnaire_answer_id"],
                      questionnaire_id: i["questionnaire_id"],
                      create_date: i["create_date"]["date"],
                      ip: i["ip"],
                      question: i["question"],
                      answer: i["answer"],
                      submitter: i["submitter"] ? i["submitter"] : "",
                    },
                  },
                );
              }}
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <button
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
              onClick={() => removeContent(i)}
            >
              <FaTrash className="text-[#D32736] h-[14px]" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="min-w-[708px] overflow-x-auto">
      <div>
        <PageHeaderV2 titlename={"รายการคำถาม"} />
        <TableSearchV1
          columns={columns}
          data={guidelineList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={totalGuideline}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มผู้ใช้งาน",
            url: "/admin/management/questionnaire/add-questionnaire",
            type: "questionnaire",
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </div>
  );
}

export default ViewQuestionnaire;
